<script setup>
await useSettings()
await useMenu()
</script>

<template>
  <div>
    <MtgsNs />
    <div class="container container--main">
      <PageNavigation />
      <slot />
      <PageSeoFooter />
      <PageFooter />
    </div>
    <ClientOnly>
      <SearchMask />
      <ModalShoppingCart />
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped></style>
